import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SearchAiIcon = function SearchAiIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "SearchAiIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      d: "M11.55 7.137a4.464 4.464 0 1 1-4.463-4.514V2.62h.023A.81.81 0 1 0 7.087 1a6.087 6.087 0 1 0 3.692 10.927l2.835 2.835a.812.812 0 0 0 1.148-1.148l-2.835-2.835a6.06 6.06 0 0 0 1.247-3.692h-.004a.81.81 0 1 0-1.62.05"
    }), jsx("path", {
      fill: "currentColor",
      d: "M10.347 7.595A.45.45 0 0 1 9.9 8c-.222 0-.406-.165-.453-.402-.362-2.113-.61-2.357-2.635-2.645A.463.463 0 0 1 6.4 4.5c0-.234.178-.424.418-.456 2.033-.231 2.321-.526 2.629-2.639A.46.46 0 0 1 9.9 1c.225 0 .406.168.447.402.368 2.113.618 2.36 2.64 2.642a.47.47 0 0 1 .413.456c0 .228-.18.424-.415.453-2.036.231-2.324.526-2.638 2.642"
    })]
  }));
};

export { SearchAiIcon };
